import { getCustomerID, getLeadID, getPhoneNo } from "../utils/storage";
import { analyticsEvent, setUserAttributes } from "./google";
import { convertUserType, generateSessionId, getUpdatedCustomerID, getVisitType, setBucketValue, setLoanType, setProductNameByID } from "./script";
import Cookies from "js-cookie";

/*------------------------------------------------*
 Events
*------------------------------------------------*/

// LOJ004 - Enter name and email
export const googleEvent_LOJ004 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "dashboard",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ004",
    event_name: "sv_user_auth",
    event_category: "screen_view",
    action: "view",
    level: "user_authenticity",
    screen_name: "user_authenticity",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ011 - sv_pan_verification
export const googleEvent_LOJ011 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "enter_your_name",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ011",
    event_name: "sv_pan_verification",
    event_category: "screen_view",
    action: "view",
    level: "pan_verification",
    screen_name: "pan_verification",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ194 - sv_pan_confirmation
export const googleEvent_LOJ194 = (panCard) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "enter_your_name",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    user_pancard: panCard,
  });

  analyticsEvent({
    event_id: "LOJ194",
    event_name: "sv_pan_confirmation",
    event_category: "screen_view",
    action: "view",
    level: "pan_confirmation",
    screen_name: "pan_confirmation",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ024 - sv_kyc_verification
export const googleEvent_LOJ024 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "pan_verification",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ024",
    event_name: "sv_kyc_verification",
    event_category: "screen_view",
    action: "view",
    level: "kyc_verification",
    screen_name: "kyc_verification",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ040 - sv_loan_purpose
export const googleEvent_LOJ040 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "enter_aadhar",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ040",
    event_name: "sv_loan_purpose",
    event_category: "screen_view",
    action: "view",
    level: "loan_purpose",
    screen_name: "loan_purpose",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ043 - sv_loan_amount
export const googleEvent_LOJ043 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "loan_purpose",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ043",
    event_name: "sv_loan_amount",
    event_category: "screen_view",
    action: "view",
    level: "loan_amount",
    screen_name: "loan_amount",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ047 - sv_gender
export const googleEvent_LOJ047 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "enter_loan_amount",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ047",
    event_name: "sv_gender",
    event_category: "screen_view",
    action: "view",
    level: "gender",
    screen_name: "gender",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ050 - sv_marital_status
export const googleEvent_LOJ050 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "gender",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ050",
    event_name: "sv_marital_status",
    event_category: "screen_view",
    action: "view",
    level: "marital_status",
    screen_name: "marital_status",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ053 - sv_personal_info
export const googleEvent_LOJ053 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "marital_status",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ053",
    event_name: "sv_personal_info",
    event_category: "screen_view",
    action: "view",
    level: "personal_info",
    screen_name: "personal_info",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ056 - sv_proff_details
export const googleEvent_LOJ056 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "personal_info",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ056",
    event_name: "sv_proff_details",
    event_category: "screen_view",
    action: "view",
    level: "proff_details",
    screen_name: "proff_details_employment",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ196 - sv_proff_details_payment
export const googleEvent_LOJ196 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "employment_details",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ196",
    event_name: "sv_proff_details_payment",
    event_category: "screen_view",
    action: "view",
    level: "proff_details_payment",
    screen_name: "proff_details_payment",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ061 - sv_employ_details
export const googleEvent_LOJ061 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "payment_mode",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ061",
    event_name: "sv_employ_details",
    event_category: "screen_view",
    action: "view",
    level: "employ_details",
    screen_name: "employ_details",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ197 - sv_employ_details_ind
export const googleEvent_LOJ197 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "company_name",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ197",
    event_name: "sv_employ_details_ind",
    event_category: "screen_view",
    action: "view",
    level: "employ_details_ind",
    screen_name: "employ_details_ind",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ198 - sv_employ_details_designation
export const googleEvent_LOJ198 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "industry",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ198",
    event_name: "sv_employ_details_designation",
    event_category: "screen_view",
    action: "view",
    level: "employ_details_designation",
    screen_name: "employ_details_designation",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ069 - sv_proff_details_mon_income
export const googleEvent_LOJ069 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "your_designation",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ069",
    event_name: "sv_proff_details_mon_income",
    event_category: "screen_view",
    action: "view",
    level: "proff_details_monthly_income",
    screen_name: "proff_details_mon_income",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ073 - sv_proff_details_work_exp
export const googleEvent_LOJ073 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "monthly_income",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ073",
    event_name: "sv_proff_details_work_exp",
    event_category: "screen_view",
    action: "view",
    level: "proff_details_work_experience",
    screen_name: "proff_details_work_exp",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ076 - sv_proff_details_sal_date
export const googleEvent_LOJ076 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "work_experience",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ076",
    event_name: "sv_proff_details_sal_date",
    event_category: "screen_view",
    action: "view",
    level: "proff_details_salary_date",
    screen_name: "proff_details_sal_date",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ079 - sv_resi_details_residence
export const googleEvent_LOJ079 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "salary_date",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ079",
    event_name: "sv_resi_details_residence",
    event_category: "screen_view",
    action: "view",
    level: "resi_details_residence",
    screen_name: "resi_details_residence",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ082 - sv_resi_details_address
export const googleEvent_LOJ082 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "your_residence",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ082",
    event_name: "sv_resi_details_address",
    event_category: "screen_view",
    action: "view",
    level: "resi_details_address",
    screen_name: "resi_details_address",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ178 - sv_reference_details
export const googleEvent_LOJ178 = (offerId) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "loan-approval",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_id: offerId,
  });

  analyticsEvent({
    event_id: "LOJ178",
    event_name: "sv_reference_details",
    event_category: "screen_view",
    action: "view",
    level: "reference_details",
    screen_name: "reference_details",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ190 - sv_one_page
export const googleEvent_LOJ190 = (offerClass, offerId) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "enter-loan-amount",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_class: offerClass,
    offer_id: offerId,
  });

  analyticsEvent({
    event_id: "LOJ190",
    event_name: "sv_one_page",
    event_category: "screen_view",
    action: "view",
    level: "one_page",
    screen_name: "one_page",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ193 - one_page_continue_clk
export const googleEvent_LOJ193 = (offerClass, offerId) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0",
    flag_prod: "1",
    previous_screen: "enter-loan-amount",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    offer_class: offerClass,
    offer_id: offerId,
  });

  analyticsEvent({
    event_id: "LOJ193",
    event_name: "one_page_continue_clk",
    event_category: "one_page",
    action: "click",
    level: "contiue",
    screen_name: "one_page",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

/*------------------------------------------------*
 Camera Permission Events
*------------------------------------------------*/

// LOJ218 - sv_allow_camera_permission
export const googleEvent_LOJ218 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ218",
    event_name: "sv_allow_camera_permission",
    event_category: "screen_view",
    action: "view",
    level: "allow_camera_permission",
    screen_name: "allow_camera_permission",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ220 - allow_camera_permission_allow_clk
export const googleEvent_LOJ220 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ220",
    event_name: "allow_camera_permission_allow_clk",
    event_category: "allow_camera_permission",
    action: "click",
    level: "allow",
    screen_name: "allow_camera_permission",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ221 - sv_enable_camera_permission
export const googleEvent_LOJ221 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ221",
    event_name: "sv_enable_camera_permission",
    event_category: "screen_view",
    action: "view",
    level: "enable_camera_permission",
    screen_name: "enable_camera_permission",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ223 - enable_camera_permission_given_clk
export const googleEvent_LOJ223 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ223",
    event_name: "enable_camera_permission_given_clk",
    event_category: "enable_camera_permission",
    action: "click",
    level: "given",
    screen_name: "enable_camera_permission",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ224 - kyc_verification_selfie_permision_vw
export const googleEvent_LOJ224 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ224",
    event_name: "kyc_verification_selfie_permision_vw",
    event_category: "kyc_verification",
    action: "view",
    level: "camera_permission",
    screen_name: "kyc_verification_selfie",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ225 - kyc_verif_selfie_perm_allow_<granted|denied|prompt>_clk
export const googleEvent_LOJ225 = (permision) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
  });

  analyticsEvent({
    event_id: "LOJ225",
    event_name: `kyc_verif_selfie_perm_allow_${permision}_clk`,
    event_category: "kyc_verification",
    action: "click",
    level: `camera_${permision}`,
    screen_name: "kyc_verification_selfie",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};

// LOJ086 - sv_sel_your_loan
export const googleEvent_LOJ086 = () => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    emi_plan: "",
    offer_type: "",
    offer_class: "",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ086",
    event_name: "sv_sel_your_loan",
    event_category: "screen_view",
    action: "view",
    level: "select_your_loan",
    screen_name: "select_your_loan",
    event_type_1: "frontend",
    event_type_2: "non_interactive",
  });
};

// LOJ090 - sel_your_loan_continue_clk
export const googleEvent_LOJ090 = (data, offer_type) => {
  setUserAttributes({
    session_id: generateSessionId(),
    customer_id: Cookies.get("customerID") || "",
    client_id: "",
    advertising_id: "",
    gclid: "",
    fcmtoken: "",
    user_type: convertUserType(),
    product_type: setProductNameByID(),
    lead_id: Number(localStorage.getItem("leadID")) || "",

    platform: "web",
    app_version: localStorage.getItem("appVersion") ?? "",
    utm_source: localStorage.getItem("utm_source") ?? "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
    user_insider: "0", // emp (1) / cust (0)
    flag_prod: "1",

    previous_screen: "bank_details_fetched",
    phone_number: getPhoneNo(),
    loan_type: setLoanType(),
    journey_type: localStorage.getItem("customerType") === "Repeat Customer" ? "one_page" : "normal",
    emi_plan: data.Titel.toLowerCase().replace(/[-\s]+/g, "_"),
    offer_type: offer_type.length === 1 ? "single" : "multiple",
    offer_class: "",
    offer_id: "",
  });

  analyticsEvent({
    event_id: "LOJ090",
    event_name: "sel_your_loan_continue_clk",
    event_category: "select_your_loan",
    action: "click",
    level: "continue",
    screen_name: "select_your_loan",
    event_type_1: "frontend",
    event_type_2: "interactive",
  });
};
